import MainImage from "../images/FairyDoor/1Finished.jpeg";
import Inspo from "../images/FairyDoor/2Inspo.jpeg";
import Drawing from "../images/FairyDoor/3Drawing.jpeg";
import Router from "../images/FairyDoor/4Router.jpeg";
import Bandsaw from "../images/FairyDoor/5Bandsaw.jpeg";
import Jointer from "../images/FairyDoor/6Jointer.jpeg";
import Planer from "../images/FairyDoor/7Planer.jpeg";
import Pieces from "../images/FairyDoor/8Pieces.jpeg";
import Assembly from "../images/FairyDoor/9Assembly.jpeg";
import Gluing from "../images/FairyDoor/10Gluing.jpeg";
import DesignOptions from "../images/FairyDoor/11DesignOptions.jpeg";
import FinalLayout from "../images/FairyDoor/12FinalLayout.jpeg";
import ClockFace from "../images/FairyDoor/13ClockFace.jpeg";
import Final from "../images/FairyDoor/14Final.jpeg";

const FairyDoorImages = [
  {
    src: MainImage,
    text: "The finished product soon after it was built."
  },
  {
    src: Inspo,
    text: "The main inspirational image for this project."
  },
  {
    src: Drawing,
    text: "Initial drawings I made to get a sense of size."
  },
  {
    src: Router,
    text: "I was able to use my father's router table to cut the vertical lines in the door."
  },
  {
    src: Bandsaw,
    text: "The bandsaw I used to cut the frame and steps of the fairy door."
  },
  {
    src: Jointer,
    text: "The jointer I used in the project."
  },
  {
    src: Planer,
    text: "The portable table top planer used in the project to neaten up the sides of the white oak and door pieces."
  },
  {
    src: Pieces,
    text: "I ended up cuting the door frame free hand in two pieces on the bandsaw. Here I'm making sure they match up."
  },
  {
    src: Assembly,
    text: "Gluing the pieces together."
  },
  {
    src: Gluing,
    text: "The initial look at the door, frame, and steps together."
  },
  {
    src: DesignOptions,
    text: "I couldn't decide how I wanted the door to look. Here are some options I contemplated. I had fun burning random designs into the door with my hot knife."
  },
  {
    src: FinalLayout,
    text: "The design I ended up going with."
  },
  {
    src: ClockFace,
    text: "I designed the clock face and had it made using a laser engraver at the maker space at WSU for a separate assignment."
  },
  {
    src: Final,
    text: "Here, I put the finishing touches on the clock itself after using a hacksaw to cut a hole for in the disc of wood."
  }
]

export default FairyDoorImages;